import React from 'react';
import { I18nSupport } from '@/utils/types';
import { Col, ComponentWithProps, Container, Row } from '@visalex/core';

import cx from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './IntroducingVisalex.module.scss';

const IntroducingVisalex: ComponentWithProps<I18nSupport> = ({ className, i18nPrefix }) => {
  const { t } = useTranslation();

  return (
    <section className={cx(className, styles['introducing-visalex'])}>
      <Container>
        <Row className={styles['introducing-visalex__content']}>
          <Col xl={8} className="mx-auto">
            <h2>{t(`${i18nPrefix}.intro.title`)}</h2>
            <p>{t(`${i18nPrefix}.intro.description`)}</p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default IntroducingVisalex;
